<!-- 開閉ボタン -->
<button
  type="button"
  class="chat-launcher"
  [attr.aria-label]="isOpen ? Constant.msgChatClose : Constant.msgChatOpen"
  [attr.aria-expanded]="isOpen"
  (click)="onToggle()">
  <mat-icon>{{ isOpen ? 'close' : 'chat_bubble' }}</mat-icon>
</button>

<!-- チャットパネル -->
<!-- 閉じても発言を保持するため、DOM は残したまま表示だけ切り替える -->
<div class="chat-panel" [class.open]="isOpen" role="dialog" [attr.aria-label]="Constant.msgChatTitle">
  <div class="chat-header">
    <span class="chat-title">{{ Constant.msgChatTitle }}</span>
    <button type="button" class="chat-close" [attr.aria-label]="Constant.msgChatClose" (click)="onToggle()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="chat-messages" #messageArea>
    <div class="chat-greeting">{{ Constant.msgChatGreeting }}</div>

    @for (message of messages; track $index) {
      <div class="chat-row" [class.user]="message.role === 'user'">
        <div class="chat-bubble" [class.user]="message.role === 'user'">
          <div class="chat-text">{{ message.content }}</div>
        </div>
      </div>
    }

    @if (isSending) {
      <div class="chat-row">
        <div class="chat-bubble chat-loading">
          <mat-spinner diameter="20"></mat-spinner>
        </div>
      </div>
    }
  </div>

  <div class="chat-input-area">
    <textarea
      class="chat-input"
      rows="2"
      [(ngModel)]="inputText"
      [maxlength]="Constant.fvMaxChatInput"
      [disabled]="isSending"
      [placeholder]="Constant.msgChatPlaceholder"
      (keydown)="onKeydown($event)"></textarea>
    <button
      type="button"
      mat-raised-button
      color="warn"
      class="chat-send"
      [disabled]="isSending || !inputText.trim()"
      (click)="onSend()">
      {{ Constant.msgChatSend }}
    </button>
  </div>
</div>
